import React, { useCallback, useEffect, useState } from "react";
import {getData, postData} from '../middleware/apiMiddleware';
import s from './SchoolGroup.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {MyInput} from './Utilities/MyInput';

export default function SchoolGroup(prop) {	
	const [group, setGroup] = useState([]);
	
	
	
	
	const navigate = useNavigate();
	let schoolId = prop.schoolId;
	const [groups, setGroups] = useState([]);
	const [showDetail, setShowDetail] = useState([]);
	
	const [detail, setDetail] = useState([]);
	const [tokenDetail, setTokenDetail] = useState([]);
	
	const [newGroupName, setNewGroupName] =  useState("");
	const [bindClassId, setBindClassId] =  useState("");
	const [bindGroupId, setBindGroupId] =  useState("");
	const [addTokenGroupId, setAddTokenGroupId] =  useState("");

	const fetchData = async () => {
		let res = await getData('schoolApi/listGroupsBySchoolId?id=' + schoolId, navigate);
		let gs = res.data;
		setGroups(gs);
		if (gs && gs[0] && gs[0].id) {
			setBindGroupId(gs[0].id);
			setAddTokenGroupId(gs[0].id);
		}
	}
	
	const fetchDetail = async (groupId) => {
		let res = await getData('schoolApi/listClassesByGroupId?id=' + groupId, navigate);
		detail[groupId] = res.data;
		setDetail({...detail});
		
		
		
		let res2 = await getData('schoolApi/listTokensByGroupId?id=' + groupId, navigate);
		tokenDetail[groupId] = res2.data;
		setTokenDetail({...tokenDetail});
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const addAllClassToGroup = async(groupId) => {
		let obj = { groupId, orgId:schoolId }
		
		await postData("schoolApi/addAllClassToGroup", obj, navigate); 
		fetchDetail(groupId);
	}
	

	
	const updateTokenAmt = async(groupId, tokenId, tokenAmt) => {
		let obj = { tokenId, tokenAmt }
		
		await postData("schoolApi/updateTokenAmt", obj, navigate); 
		fetchDetail(groupId);
	}
	
	const updateTokenExpiry = async(groupId, tokenId, expiryDate) => {
		let obj = { tokenId, expiryDate }
		
		await postData("schoolApi/updateTokenExpiry", obj, navigate); 
		fetchDetail(groupId);
	}
	
	const removeClassFromGroup = async(classId, groupId) => {
		let obj = { classId, groupId }

		await postData("schoolApi/removeClassFromGroup", obj, navigate); 
		fetchDetail(groupId);
	}
	
	const createNewGroupName = async() => {
		let obj = { orgId:schoolId, name:newGroupName }
		
		await postData("schoolApi/createGroup", obj, navigate); 
		fetchData();		
	}
	
	const bindClassToGroup = async() => {
		let obj = { groupId:bindGroupId, classId:bindClassId }

		await postData("schoolApi/bindClassToGroup", obj, navigate); 
		fetchDetail(bindGroupId);
		setBindGroupId(groups[0].id);
	}
	
	
	const addTokenToGroup = async() => {
		
		
		let obj = { groupId:addTokenGroupId }
		await postData("schoolApi/addTokenToGroup", obj, navigate); 
		setAddTokenGroupId("");
		fetchDetail(bindGroupId);
	}
	
	
	
	return (<div style={{margin:"20px"}}>
		
		<div className={s.paramHolder}>
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle} style={{width:"120px"}}>
						<span>New Group</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.itemHolder}>
					<input value={newGroupName} style={{width:"200px"}} onChange={(e)=>{
						setNewGroupName(e.target.value);
					}} />
					<div className={(newGroupName) ? s.btnActive : s.btnInactive} onClick={createNewGroupName}>
						create
					</div>
				</div>
			</div>
			
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle} style={{width:"120px"}}>
						<span>Bind Class</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.itemHolder}>
					<input value={bindClassId} style={{width:"200px"}} onChange={(e)=>{
						setBindClassId(e.target.value);
					}} />
				</div>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle} style={{width:"120px"}}>
						<span>to Group</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div style={{display:"flex", padding:"5px"}}>
				
					<select className={s.selectorStyle} value={bindGroupId} onChange={
						(e)=>{
							setBindGroupId(e.target.value)
						}}>
						{
							groups.map((c, indexC) => (<option value={c.id}>
								{c.id} - {c.name}
							</option>))
						}
					</select>
				
				</div>
				<div>
					<div className={(bindGroupId && groups.length > 0) ? s.btnActive : s.btnInactive} onClick={bindClassToGroup}>
						bind
					</div>
				</div>
			</div>
			
			
			
			
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle} style={{whiteSpace:"nowrap"}}>
						<span>Add Token to Group:</span>
					</div>
				</div>
				<div style={{display:"flex", padding:"5px"}}>
				
					<select className={s.selectorStyle} value={addTokenGroupId} onChange={
						(e)=>{
							setAddTokenGroupId(e.target.value)
						}}>
						{
							groups.map((c, indexC) => (<option value={c.id}>
								{c.id} - {c.name}
							</option>))
						}
					</select>
				
				</div>
				<div>
					<div className={(groups.length > 0 && addTokenGroupId) ? s.btnActive : s.btnInactive} onClick={addTokenToGroup}>
						Add
					</div>
				</div>
			</div>
			
			
			
		</div>
	
		{
			groups.map((c, indexC) => {
				return (
				<div className={s.studentHolder} style={(indexC % 2 == 0) ? {background:"#d8e7f2", margin:"10px 0"} : {background:"#ebc5b9", margin:"10px 0"}}>
				
					<div style={{display:"flex", textAlign:"left", justifyContent:"start", background:"white", padding:"5px 0 5px 0", margin:"0 0 5px 0"}}>
						<div style={{width:"60px"}} className={s.btnLitActive} onClick={()=>{
							if (!showDetail[c.id]) {
								showDetail[c.id] = [];
							}
							showDetail[c.id][indexC] = (showDetail[c.id][indexC]) ? !showDetail[c.id][indexC] : true;
							setShowDetail({...showDetail})
							
							fetchDetail(c.id);
						}}>
							show
						</div>
							Group Id: <span style={{fontWeight:"bold", marginLeft:"5px"}}>{c.id}</span><span style={{width:"20px"}}></span>
							Group Name: <span style={{fontWeight:"bold", marginLeft:"5px"}}>{c.name}</span>
					</div>
					
					
					
					{
						(showDetail[c.id] && showDetail[c.id][indexC]) && (<div>
				
							<div style={{display:"flex"}}>
								<div style={{margin:"0 10px",flex: "0.1",textAlign:"left", width:"100%", color:(indexC % 2 == 0) ? "#465f63" : "#704335", fontWeight:"bold", whiteSpace:"nowrap"}}>Token</div>
								</div>
						
							{
								(tokenDetail[c.id] && tokenDetail[c.id].length > 0) && (<div style={{background:"white"}}>
								
									{
										tokenDetail[c.id].map((t, indexT) => (<div style={{display:"flex", alignItems:"center"}}>
											<div style={{margin:"0 10px",flex: "0 1 auto", textAlign:"left"}}>ID: {t.id}</div>
											
											<div style={{margin:"0 5px",flex: "0 1 0", textAlign:"left", whiteSpace:"nowrap"}}>Token {t.usedAmt} / </div>
											
											<input type="number" min="0" step="1" value={t.tokenAmt} style={{flex: "0 1 200px", minWidth: "20px", marginRight:"20px"}} onChange={(e)=>{	
												tokenDetail[c.id][indexT].tokenAmt = (e.target.value) ? Math.round(e.target.value) : "";
												setTokenDetail({...tokenDetail});
											}} />
											<div style={{marginRight:"20px"}}>
												<GreenButton isEnabled={(t.tokenAmt)} clickedAction={()=>{updateTokenAmt(c.id, t.id, t.tokenAmt)}} bText={"Update"} />
											</div>
										
											<div style={{margin:"0 5px",flex: "0 1 0", textAlign:"left", whiteSpace:"nowrap"}}>Expiry Date: </div>
											<input value={t.expiryDate} style={{flex: "0 1 200px", minWidth: "20px", marginRight:"20px"}} onChange={(e)=>{	
												tokenDetail[c.id][indexT].expiryDate = e.target.value;
												setTokenDetail({...tokenDetail});
											}} />
											
											<div>
												<GreenButton isEnabled={true} clickedAction={()=>{updateTokenExpiry(c.id, t.id, t.expiryDate)}} bText={"Update"} />
											</div>
										
										</div>))
									}
								</div>)
							}


							<div style={{display:"flex", alignItems:"center"}}>
								<div style={{margin:"0 10px",flex: "0 1 50px",textAlign:"left", color:(indexC % 2 == 0) ? "#465f63" : "#704335", fontWeight:"bold", whiteSpace:"nowrap"}}>group id</div>
								<div style={{margin:"0 10px",flex: "0 1 100px",textAlign:"left", color:(indexC % 2 == 0) ? "#465f63" : "#704335", fontWeight:"bold"}}>(Cnt) name</div>
								
								<div style={{margin:"0 0 0 auto"}}>
									<GreenButton isEnabled={true} clickedAction={()=>{addAllClassToGroup(c.id)}} bText={"Add all classes"} />
								</div>
							</div>
						
							{
								(detail[c.id] && detail[c.id].length > 0) && (<div style={{background:"white"}}>
									{
										detail[c.id].map((s, indexS) => (<div style={{display:"flex", alignItems:"center"}}>
											<div style={{margin:"0 10px",flex: "0 1 50px", textAlign:"left"}}>{s.id}</div>
											<div style={{margin:"0 10px",flex: "0 1 100px", textAlign:"left"}}>({s.userCnt}) {s.name}</div>
											<div style={{margin:"0 0 0 auto"}}>
												<RedButton isEnabled={true} clickedAction={()=>{removeClassFromGroup(s.id, c.id)}} bText={"Remove"} />
											</div>
										</div>))
									}
								</div>)
							}

						</div>)
					}
					
				</div>)
			})
		}
	</div>)
	
}
